module.exports = "images/cart.png";